import React, { useState } from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import AmazonSection from '../components/AmazonSection';
import PricingSection from '../components/PricingSection';
import HowItWorksSection from '../components/HowItWorksSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import InquiryModal from '../components/InquiryModal';

const Home = ({ onOpenModal }) => {
  return (
    <div className="min-h-screen">
      <HeroSection onOpenModal={onOpenModal} />
      <AboutSection onOpenModal={onOpenModal} />
      <HowItWorksSection onOpenModal={onOpenModal} />
      <ServicesSection onOpenModal={onOpenModal} />
      <AmazonSection onOpenModal={onOpenModal} />
      <PricingSection onOpenModal={onOpenModal} />
      <WhyChooseUsSection onOpenModal={onOpenModal} />
      <TestimonialsSection />
      <CTASection onOpenModal={onOpenModal} />
    </div>
  );
};

export default Home;